"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCommentFromUpdate = exports.addCommentFromUpdate = exports.deleteComment = exports.createConversationAndInitialComment = exports.saveComment = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _constants = require("composer-lib/lib/constants");

var _CommentsManager = _interopRequireDefault(require("composer-lib/data/CommentsManager"));

var _ConversationsManager = _interopRequireDefault(require("composer-lib/data/ConversationsManager"));

var _utils = require("composer-lib/lib/utils");

var commentsManager = new _CommentsManager.default();
var conversationsManager = new _ConversationsManager.default();
var saveCommentPending = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMMENT_PENDING);
var saveCommentSucceeded = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMMENT_SUCCEEDED);
var saveCommentFailed = (0, _utils.createAction)(_ActionTypes.default.SAVE_COMMENT_FAILED);

function dispatchSaveComment(dispatch, message, correlationId, objectId, portalId, authorId, conversationId) {
  dispatch(saveCommentPending({}, (0, _defineProperty2.default)({}, _constants.TRACK_EVENT_META_KEY, {
    action: 'comment-added',
    name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION
  })));
  commentsManager.createComment({
    message: message,
    correlationId: correlationId,
    objectId: objectId,
    portalId: portalId,
    authorId: authorId,
    conversationId: conversationId
  }).then(function (resp) {
    return dispatch(saveCommentSucceeded(resp));
  }, function (resp) {
    return dispatch(saveCommentFailed(resp));
  });
}

var saveComment = function saveComment(message, correlationId, objectId, portalId, authorId, conversationId) {
  return function (dispatch) {
    dispatchSaveComment(dispatch, message, correlationId, objectId, portalId, authorId, conversationId);
  };
};

exports.saveComment = saveComment;
var createConversationPending = (0, _utils.createAction)(_ActionTypes.default.CREATE_CONVERSATION_PENDING);
var createConversationSucceeded = (0, _utils.createAction)(_ActionTypes.default.CREATE_CONVERSATION_SUCCEEDED);
var createConversationFailed = (0, _utils.createAction)(_ActionTypes.default.CREATE_CONVERSATION_FAILED);

var createConversationAndInitialComment = function createConversationAndInitialComment(message, correlationId, objectId, portalId, authorId, conversationData) {
  return function (dispatch) {
    dispatch(createConversationPending());
    conversationsManager.create(correlationId, objectId, conversationData.highlightStart, conversationData.highlightEnd, conversationData.highlightText).then(function (conversation) {
      dispatch(createConversationSucceeded({
        conversation: conversation,
        dummyId: conversationData.id
      }));
      dispatchSaveComment(dispatch, message, correlationId, objectId, portalId, authorId, conversation.id);
    }, function (resp) {
      return dispatch(createConversationFailed(resp));
    });
  };
};

exports.createConversationAndInitialComment = createConversationAndInitialComment;
var deleteCommentPending = (0, _utils.createAction)(_ActionTypes.default.DELETE_COMMENT_PENDING);
var deleteCommentSucceeded = (0, _utils.createAction)(_ActionTypes.default.DELETE_COMMENT_SUCCEEDED);
var deleteCommentFailed = (0, _utils.createAction)(_ActionTypes.default.DELETE_COMMENT_FAILED);

var deleteComment = function deleteComment(comment) {
  return function (dispatch) {
    dispatch(deleteCommentPending(comment, (0, _defineProperty2.default)({}, _constants.TRACK_EVENT_META_KEY, {
      action: 'comment-deleted',
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION
    })));
    commentsManager.deleteComment(comment.id).then(function () {
      return dispatch(deleteCommentSucceeded(comment));
    }, function (resp) {
      return dispatch(deleteCommentFailed(resp));
    });
  };
};

exports.deleteComment = deleteComment;

var addCommentFromUpdate = function addCommentFromUpdate(commentData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_ADD_COMMENT)(commentData));
  };
};

exports.addCommentFromUpdate = addCommentFromUpdate;

var deleteCommentFromUpdate = function deleteCommentFromUpdate(commentData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REALTIME_DELETE_COMMENT)(commentData));
  };
};

exports.deleteCommentFromUpdate = deleteCommentFromUpdate;